import { useState, useEffect, useRef } from "react"
import { X, Copy, Check, Info, Tag } from "lucide-react"
import authService from '../../../Services/authService';




export default function CouponsModal({ isOpen, onClose, onApply, appliedCouponCode }) {
  const [copiedCode, setCopiedCode] = useState(null)
  const [expandedCoupon, setExpandedCoupon] = useState(null)
  //const [searchQuery, setSearchQuery] = useState("")
  //const [filteredCoupons, setFilteredCoupons] = useState(coupons)

  const [Offers, setOffers] = useState([]);
  const token = authService.getCurrentUsertoken();
  const modalRef = useRef(null)

  // Filter coupons based on search query
  // useEffect(() => {
  //   if (searchQuery.trim() === "") {
  //     setFilteredCoupons(coupons)
  //   } else {
  //     const query = searchQuery.toLowerCase()
  //     const filtered = coupons.filter(
  //       (coupon) =>
  //         coupon.code.toLowerCase().includes(query) ||
  //         coupon.title.toLowerCase().includes(query) ||
  //         coupon.description.toLowerCase().includes(query),
  //     )
  //     setFilteredCoupons(filtered)
  //   }
  // }, [searchQuery])

  // Close modal when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isOpen, onClose])

  useEffect(() => {

    loadOffers();

  }, []);

  const loadOffers = () => {

    const url = new URL(authService.getApiUrl() + 'alloffers');

    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => {
        // if (res.status === 401) {
        //   authService.clientlogout();
        //   window.location.href = "/login";
        // } else {
        return res.json();
        //}
      })
      .then((result) => {
        setOffers(result.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  // Handle copy coupon code
  const handleCopyCode = (code) => {
    navigator.clipboard.writeText(code)
    setCopiedCode(code)
    setTimeout(() => setCopiedCode(null), 2000)
  }

  // Toggle coupon details
  const toggleCouponDetails = (couponId) => {
    if (expandedCoupon === couponId) {
      setExpandedCoupon(null)
    } else {
      setExpandedCoupon(couponId)
    }
  }

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div
        ref={modalRef}
        className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-0 bg-white z-10 flex justify-between items-center p-4 border-b border-[#E0E0E0]">
          <div className="flex items-center">
            <Tag size={20} className="text-[#951C25] mr-3" />
            <h2 className="text-lg font-medium text-[#4A4A4A]">Available Coupons</h2>
          </div>
          <button onClick={onClose} className="text-[#4A4A4A] hover:text-[#951C25]">
            <X size={20} />
          </button>
        </div>

        {/* Search Bar */}
        {/* <div className="p-4 border-b border-[#E0E0E0]">
          <div className="relative">
            <input
              type="text"
              placeholder="Search for coupons"
              className="w-full pl-10 pr-4 py-2 border border-[#E0E0E0] rounded-lg focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-[#4A4A4A]/50"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </div>
          </div>
        </div> */}

        {/* Coupons List */}
        <div className="p-4">
          <div className="space-y-4">
            {Offers.map((coupon) => (
              <div key={coupon.id} className="bg-white rounded-lg border border-[#E0E0E0] overflow-hidden">
                {/* Coupon Header */}
                <div className="p-4 border-b border-[#E0E0E0]">
                  <div className="flex justify-between items-start">
                    <div>
                      <div className="flex items-center">
                        <h2 className="text-lg font-medium text-[#4A4A4A]">{coupon.offer_title}</h2>
                        {/* {coupon.isPopular && (
                        <span className="ml-2 text-xs bg-[#951C25]/10 text-[#951C25] px-2 py-0.5 rounded">Popular</span>
                      )} */}
                      </div>
                      <p className="text-sm text-[#4A4A4A]/70 mt-1">Discount {coupon.discount_percentage}%</p>
                    </div>
                    <div className="flex flex-col items-end">
                      <div className="flex items-center mb-2">
                        <div className="px-3 py-1.5 bg-[#F5F5F7] border border-[#E0E0E0] rounded mr-2 font-mono text-sm">
                          {coupon.coupon_code}
                        </div>
                        <button
                          onClick={() => handleCopyCode(coupon.coupon_code)}
                          className="w-8 h-8 flex items-center justify-center rounded-full bg-[#951C25]/10 text-[#951C25] hover:bg-[#951C25]/20"
                        >
                          {copiedCode === coupon.coupon_code ? <Check size={16} /> : <Copy size={16} />}
                        </button>
                      </div>
                      {appliedCouponCode === coupon.coupon_code ? (
                        <span className="text-green-600 font-semibold text-sm">Applied</span>
                      ) : (
                        <button
                          onClick={() => onApply(coupon)}
                          className="px-4 py-1.5 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90"
                        >
                          Apply
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Coupon Details */}
                <div className="px-4 py-3 bg-[#F5F5F7]/50 flex justify-between items-center">
                  <div className="flex items-center">
                    {/* <div className="flex items-center mr-4">
                    <span className="text-xs text-[#4A4A4A]/70 mr-1">Min. Order:</span>
                    <span className="text-sm font-medium text-[#4A4A4A]">₹{coupon.minOrderValue}</span>
                  </div> */}
                    <div className="flex items-center">
                      <span className="text-xs text-[#4A4A4A]/70 mr-1">Valid till:</span>
                      <span className="text-sm font-medium text-[#4A4A4A]">{formatDate(coupon.end_date)}</span>
                    </div>
                  </div>
                  <button
                    onClick={() => toggleCouponDetails(coupon.id)}
                    className="flex items-center text-xs text-[#951C25]"
                  >
                    <Info size={14} className="mr-1" />
                    {expandedCoupon === coupon.id ? "Hide Details" : "View Details"}
                  </button>
                </div>

                {/* Expanded Terms and Conditions */}
                {expandedCoupon === coupon.id && (
                  <div className="p-4 bg-[#F5F5F7]/30 border-t border-[#E0E0E0]">
                    <h3 className="text-sm font-medium text-[#4A4A4A] mb-2">Terms & Conditions</h3>
                    <ul className="list-disc list-inside space-y-1">
                      {coupon.offerdetails?.map((term, index) => (
                        <li key={index} className="text-xs text-[#4A4A4A]/70">
                          {term.details}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
          {Offers.length === 0 && (
            <div className="bg-white rounded-lg border border-[#E0E0E0] p-8 text-center">
              <div className="w-16 h-16 rounded-full bg-[#951C25]/10 flex items-center justify-center mx-auto mb-4">
                <Tag size={24} className="text-[#951C25]" />
              </div>
              <h2 className="text-lg font-medium text-[#4A4A4A] mb-2">No Coupons Available</h2>
              <p className="text-sm text-[#4A4A4A]/70">
                There are currently no active coupons available for your account.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}